export const SOFTLINE_API_ABSATZPLAN_QUERY = '/v1/absatzplan/query';
export const SOFTLINE_API_ABSATZPLAN_KOPF_VORHANDEN = '/v1/absatzplan/kopf/vorhanden';
export const SOFTLINE_API_ABSATZPLAN_KOPF_TEMP_LOESCHEN = '/v1/absatzplan/kopf/temp-loeschen';
export const SOFTLINE_API_ABSATZPLAN_ENTITY = '/v1/absatzplan/entities';
export const SOFTLINE_API_ABSATZPLAN_SAVE = '/v1/absatzplan/save';
export const SOFTLINE_API_ABSATZPLAN_COPY = '/v1/absatzplan/copy';
export const SOFTLINE_API_ABSATZPLAN_EXPORT_CSV = '/v1/absatzplan/csv';
export const SOFTLINE_API_ABSATZPLAN_REZEPTUR_AUFLOESEN = '/v1/absatzplan/entities/{{id}}/rezepturaufloesen';
export const SOFTLINE_API_PRODUKTION_ABSATZPLAN = '/v1/absatzplan/monate';

